import { render } from "./HeroNoDataGrid.vue?vue&type=template&id=0f4fb928&scoped=true"
import script from "./HeroNoDataGrid.vue?vue&type=script&lang=js"
export * from "./HeroNoDataGrid.vue?vue&type=script&lang=js"

import "./HeroNoDataGrid.vue?vue&type=style&index=0&id=0f4fb928&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4fb928"]])

export default __exports__